<template>
  <v-dialog :value="dlg" max-width="500">
    <v-card>
      <v-card-title class="alertTitle headline yellow darken-3" primary-title>
        {{ title || "Oops!" }}
      </v-card-title>
      <v-card-text class="alertMessage pt-0 yellow darken-3">
        {{ message || "It looks like something went wrong." }}
      </v-card-text>
      <img :src="errorPicture" class="alertImage" />
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" flat @click="$emit('dismissed')">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ['title', 'message', 'dlg'],
    data: () => ({
      errorPicture: ''
    }),
    watch: {
      dlg(after, before) {
        if (!before && after) {
          this.errorPicture = this.randomPicture()
        }
      }
    },
    methods: {
      randomPicture() {
        const errorPicCount = 5
        const { floor, random } = Math
        const rnd = 1 + floor(random() * errorPicCount)
        return `assets/images/error-${rnd}.jpg`
      }
    }
  }
</script>

<style scoped>
  .alertImage {
    width: 100%;
  }

  .alertMessage {
    font-size: 17px;
  }
</style>
